import pointCut from "toggle:/point-cuts:/experimental react components";
import * as joinPoint from "/components/StyleCount/index.js";
const variants = import.meta.webpackContext("/components/StyleCount", { recursive: true, regExp: /\.\/__variants__\/plp\-search\-results\-ranges\/v2\/index\.js/ });
export default pointCut({ joinPoint, variants });